import type { User } from '@/types';

/**
 * Whether the user should get Agency product flows (add company seat confirm,
 * agency billing tab) even when self-serve Agency signup is paused.
 */
export function isAgencyOwnerForProduct(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.accountType === 'agency_owner') return true;
  if (user.agency) return true;
  if (user.agencyPlanId) return true;
  if (user.billing?.planId?.startsWith('agency_')) return true;
  if (user.hasAgencyWorkspace) return true;
  return false;
}
